<template>
  <div class="page">
    <template v-if="userId">
      <!-- 1. 顶部导航栏：Tab + 右侧工具 -->
      <div class="header-bar">
        <!-- 左侧 Tabs -->
        <ul class="tab-list">
          <li
            v-for="tab in tabs"
            :key="tab.id"
            :class="{ active: activeTab === tab.id }"
            @click="handleTabChange(tab.id)"
          >
            <span>{{ tab.name }}</span>
            <div class="active-line" v-if="activeTab === tab.id"></div>
          </li>
        </ul>

        <!-- 右侧工具：地区选择 + 定位 -->
        <div class="header-tools" v-if="activeTab === 'nearby'">
          <el-select
            v-model="sheng"
            placeholder="省"
            filterable
            clearable
            size="small"
            class="region-select"
            @change="handleChange($event, 1)"
          >
            <el-option
              v-for="(item, index) in addressList"
              :key="index + 'sheng'"
              :label="item.name"
              :value="item.code"
            >
            </el-option>
          </el-select>

          <!-- 市 -->
          <el-select
            v-model="shi"
            placeholder="市"
            filterable
            clearable
            size="small"
            class="region-select"
            @change="handleChange($event, 2)"
          >
            <el-option
              v-for="(item, index) in shiList"
              :key="index + 'shi'"
              :label="item.name"
              :value="item.code"
            >
            </el-option>
          </el-select>

          <!-- 县 -->
          <el-select
            v-model="xian"
            placeholder="县"
            filterable
            clearable
            size="small"
            class="region-select"
            @change="handleChange($event, 3)"
          >
            <el-option
              v-for="(item, index) in xianList"
              :key="index + 'xian'"
              :label="item.name"
              :value="item.code"
            >
            </el-option>
          </el-select>

          <div class="location-btn" @click="initLocation">
            <i class="el-icon-aim"></i>
            <span>定位当前位置</span>
          </div>
        </div>
        <p class="tip" v-else-if="activeTab === 'follow'">
          注：非会员最多关注10个，VIP会员最多可关注40个(购买或安装气象站，均可以获得VIP会员资质)
        </p>
      </div>

      <!-- 2. 站点网格列表 -->
      <div class="grid-container">
        <ul class="station-grid" v-if="marker.length > 0">
          <li
            v-for="item in marker"
            :key="item.id"
            class="station-card"
            :class="{ 'is-offline': item.status != 1 }"
            @click="choseDetails(item)"
          >
            <!-- 图片区域 -->
            <div class="card-img-box">
              <img
                class="poster"
                :src="getStationImg(item)"
                :alt="item.deviceName"
                @error="handleImgError"
              />

              <!-- 悬浮：状态标签 -->
              <div class="status-tag">
                <span class="dot"></span>
                {{ item.status == 1 ? "在线" : "离线" }}
              </div>

              <!-- 悬浮：关注按钮 -->
              <div class="follow-action" @click.stop="toggleFollow(item)">
                <i
                  class="icon"
                  :class="item.isFollow ? 'follow-icon' : 'unfollow-icon'"
                  :style="{ color: item.isFollow ? '#f7ba2a' : '#ccc' }"
                ></i>
              </div>
              <div class="info-panel">
                <div class="device-info">
                  <img :src="item.icon" alt="" class="icon" />
                  <div class="info-header">
                    <h3 class="device-name" :title="item.deviceName">
                      {{ item.deviceName }}
                    </h3>
                    <p class="time">
                      更新时间{{ item.lastUploadTime || "无" }}
                    </p>
                  </div>
                  <span class="device-type">{{ item.deviceType }}</span>
                </div>
                <div class="card-info">
                  <div class="owner">站主：{{ item.siteOwner || "未知" }}</div>
                  <div class="info-remark">
                    描述：{{ item.remarks || "暂无" }}
                  </div>
                </div>
              </div>
            </div>
          </li>
        </ul>

        <!-- 空状态 -->
        <div class="empty-placeholder" v-else>
          <div class="empty-img">
            <i class="el-icon-receiving"></i>
          </div>
          <p>暂无相关站点数据</p>
        </div>
      </div>
    </template>
    <div class="login-prompt" v-else>
      <p>
        您尚未登录系统，请
        <span class="login-link" @click="goin()">立即登录</span>
        管理您的站点
      </p>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { $device } from "@/services";
import defaultStationImg from "@/assets/defaultCover.png"; // 默认图
import { addressList } from "./cityData";

export default {
  name: "gispersonal",
  data() {
    return {
      activeTab: "own",
      tabs: [
        { id: "own", name: "我的气象站" },
        { id: "follow", name: "关注气象站" },
        { id: "recommend", name: "推荐气象站" },
        { id: "nearby", name: "附近气象站" },
      ],
      marker: [],
      userCoords: { lng: 116.4, lat: 39.9 },
      defaultImg: defaultStationImg || "",

      // 省市县联动数据
      addressList: addressList || [], // 城市源数据
      shiList: [],
      xianList: [],
      sheng: "",
      shi: "",
      xian: "",

      // 用于筛选的名称（因为列表数据中address是中文，需要将code转为name）
      filterNames: {
        sheng: "",
        shi: "",
        xian: "",
      },
    };
  },
  computed: {
    ...mapState({
      userInfo: (state) => state.user.userInfo,
      token: (state) => state.user.token,
      userId: (state) => state.user.userInfo?.id || "",
      currentUserName: (state) => state.user.userInfo?.userName || "",
    }),
    // 本地多重筛选
    filteredList() {
      let list = this.marker;

      // 1. 省份筛选
      if (this.filterNames.sheng) {
        list = list.filter(
          (item) =>
            item.address && item.address.includes(this.filterNames.sheng)
        );
      }
      // 2. 城市筛选
      if (this.filterNames.shi) {
        list = list.filter(
          (item) => item.address && item.address.includes(this.filterNames.shi)
        );
      }
      // 3. 区县筛选
      if (this.filterNames.xian) {
        list = list.filter(
          (item) => item.address && item.address.includes(this.filterNames.xian)
        );
      }

      return list;
    },
  },
  watch: {
    userId: {
      handler(newVal) {
        if (newVal) {
          this.initLocation();
        }
      },
      immediate: true, // 组件创建时立即执行一次
    },
  },
  methods: {
    handleChange(value, type) {
      let webCode = value;

      if (type === 1) {
        // 选择省：清空市、县数据
        this.shi = "";
        this.xian = "";
        this.shiList = [];
        this.xianList = [];

        if (value) {
          const obj = this.addressList.find((item) => item.code === value);
          if (obj) {
            this.shiList = obj.children || [];
          }
        }
      } else if (type === 2) {
        // 选择市：清空县数据
        this.xian = "";
        this.xianList = [];

        if (value) {
          const obj = this.shiList.find((item) => item.code === value);
          if (obj) {
            this.xianList = obj.children || [];
          }
        }
      } else if (type === 3) {
        // 选择县：仅记录
      }

      // 如果当前选择被清空，尝试回退到上一级 Code
      if (!webCode) {
        if (type === 3 && this.shi) {
          webCode = this.shi;
        } else if (type === 2 && this.sheng) {
          webCode = this.sheng;
        } else if (type === 1) {
          // 如果省份也清空了，恢复默认列表（根据当前Tab）
          this.fetchListData();
          return;
        }
      }

      // 手动选择地区，发起请求（只传 webCode）
      this.fetchListData(webCode);
    },

    // 根据返回的 webCode 回显省市区下拉框
    setRegionBackfill(webCode) {
      if (!webCode) return;

      // 假设 webCode 格式标准：前2位省，前4位市，前6位县
      const shengPrefix = webCode.substring(0, 2);
      const shiPrefix = webCode.length >= 4 ? webCode.substring(0, 4) : null;
      const xianCode = webCode.length >= 6 ? webCode : null;

      // 1. 匹配省
      const shengObj = this.addressList.find((item) =>
        item.code.startsWith(shengPrefix)
      );
      if (shengObj) {
        this.sheng = shengObj.code;
        this.shiList = shengObj.children || [];

        // 2. 匹配市
        if (shiPrefix) {
          const shiObj = this.shiList.find((item) =>
            item.code.startsWith(shiPrefix)
          );
          if (shiObj) {
            this.shi = shiObj.code;
            this.xianList = shiObj.children || [];

            // 3. 匹配县
            if (xianCode) {
              const xianObj = this.xianList.find(
                (item) => item.code === xianCode
              );
              if (xianObj) {
                this.xian = xianObj.code;
              } else {
                this.xian = "";
              }
            } else {
              this.xian = "";
            }
          } else {
            this.shi = "";
            this.xianList = [];
          }
        } else {
          this.shi = "";
        }
      }
    },
    // 获取图片URL逻辑
    getStationImg(item) {
      if (
        item.imgInfo &&
        item.imgInfo.length > 0 &&
        item.imgInfo[0].file &&
        item.imgInfo[0].file.length > 0 &&
        item.imgInfo[0].file[0].url
      ) {
        return item.imgInfo[0].file[0].url;
      }
      return this.defaultImg;
    },

    handleImgError(e) {
      e.target.src = this.defaultImg;
    },

    handleTabChange(id) {
      if (this.activeTab === id) return;
      this.activeTab = id;
      this.fetchListData();
    },

    initLocation() {
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(
          (pos) => {
            this.userCoords = {
              lng: pos.coords.longitude,
              lat: pos.coords.latitude,
            };
            this.$message.success("定位成功");

            // 清空手动选择，确保使用定位坐标查询
            this.sheng = "";
            this.shi = "";
            this.xian = "";
            this.shiList = [];
            this.xianList = [];

            this.fetchListData();
          },
          () => {
            this.$message.warning("定位失败，使用默认位置");
            this.fetchListData();
          }
        );
      } else {
        this.fetchListData();
      }
    },

    async fetchListData(code) {
      this.marker = [];
      let res;
      const params = { userId: this.userId };

      try {
        switch (this.activeTab) {
          case "own":
            res = await $device.getUserDeviceList({
              userId: this.userId,
              ...params,
            });
            break;

          case "follow":
            res = await $device.getWeatherStationFollowList({
              userId: this.userId,
              ...params,
            });
            break;

          case "nearby":
            // 如果没有传入 code，且当前是附近站点tab，尝试使用已选择的地区（解决Tab切换后回退到经纬度查询的问题）
            if (!code) {
              if (this.xian) code = this.xian;
              else if (this.shi) code = this.shi;
              else if (this.sheng) code = this.sheng;
            }

            if (code) {
              params.webCode = code;
            } else {
              params.lng = this.userCoords.lng;
              params.lat = this.userCoords.lat;
            }
            res = await $device.getNearbyStationsKList(params);
            break;

          case "recommend":
            res = await $device.getRecommendList(params);
            break;
        }

        if (res && res.success) {
          const list = res.data.list || res.data;
          const webCode = res.data.webCode;

          this.formatList(list);
          // 如果有返回 webCode，则回显到下拉框
          if (webCode) {
            this.setRegionBackfill(webCode);
          }
        } else {
          this.$message.warning(res.msg || "未查询到相关数据");
        }
      } catch (e) {
        this.$message.error("获取数据失败");
        console.error(e);
      }
    },
    formatList(list) {
      this.marker = list.map((item) => {
        const typeStr = (item.deviceType || "").toLowerCase();
        let icon = require("@/assets/markers/3.png");
        if (typeStr.includes("wifi"))
          icon = require("@/assets/markers/wifi.png");
        else if (typeStr.includes("4g"))
          icon = require("@/assets/markers/4g.png");
        else if (typeStr.includes("s1"))
          icon = require("@/assets/markers/s1.png");
        return {
          ...item,
          imgInfo: item.imgInfo ? JSON.parse(item.imgInfo) : [],
          icon,
        };
      });
    },

    async toggleFollow(item) {
      try {
        const params = { userId: this.userId, device: item.device };
        const apiFunc = item.isFollow
          ? $device.unfollowDevice
          : $device.followDevice;
        const res = await apiFunc(params);
        if (res.code === 200) {
          this.$message.success(item.isFollow ? "已取消关注" : "关注成功");
          if (this.activeTab === "follow" && item.isFollow) {
            this.marker = this.marker.filter((m) => m.device !== item.device);
          } else {
            item.isFollow = !item.isFollow;
          }
        }
      } catch (e) {
        this.$message.error("操作失败");
      }
    },

    choseDetails(cur) {
      this.$router.push({ name: "site", query: { device: cur.device } });
    },

    goin() {
      this.$router.push({
        name: "login",
        query: { redirect: this.$route.fullPath },
      });
    },
  },
};
</script>

<style lang="less" scoped>
.page {
  width: 100%;
  min-height: calc(100vh - 50px);
  background-color: #f4f9fc;
  .login-prompt {
    text-align: center;
    padding: 100px 0;
    color: #64748b;
    .login-link {
      color: #0ea5e9;
      font-weight: 600;
      cursor: pointer;
      margin: 0 4px;
      &:hover {
        text-decoration: underline;
      }
    }
  }
  /* 顶部 Header */
  .header-bar {
    display: flex;
    justify-content: space-between;
    align-items: center;
    background: #f0f0f0;
    padding: 0 82px;
    height: 64px;
    border-radius: 8px;
    margin-bottom: 24px;

    .tab-list {
      display: flex;

      li {
        cursor: pointer;
        font-size: 14px;
        color: #636366;
        font-weight: 400;
        width: 100px;
        height: 43px;
        display: flex;
        align-items: center;
        justify-content: center;
        transition: all 0.3s;
        border-radius: 22px;

        &.active {
          background: linear-gradient(116deg, #13e3ea 0%, #5a86fc 100%);
          color: #fff;
          font-weight: 600;
        }
      }
    }

    .header-tools {
      display: flex;
      align-items: center;
      gap: 16px;

      .region-select {
        width: 110px;
      }

      .location-btn {
        display: flex;
        align-items: center;
        gap: 4px;
        color: #000;
        cursor: pointer;
        font-size: 14px;
        padding: 6px 8px;
        background: #ffffff;
        box-shadow: 0px 0px 4px 0px rgba(0, 0, 0, 0.06);
        border-radius: 13px;
        border: 1px solid #e5e5ea;
        transition: all 0.3s;

        &:hover {
          background: #9fd5f2;
        }

        i {
          font-size: 16px;
        }
      }
    }
    .tip {
      color: #8e8e93;
      font-weight: 600;
      font-size: 12px;
    }
  }
  .grid-container {
    padding: 0 82px;
  }
  /* 2. 网格布局 */
  .station-grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(340px, 1fr));
    gap: 14px;
    font-size: 12px;
    line-height: 1.2;
    list-style: none;
    padding: 0;
    margin: 0;

    .station-card {
      height: 270px;
      background: #fff;
      border-radius: 8px;
      overflow: hidden;
      cursor: pointer;
      transition: all 0.3s ease;
      border: 1px solid #e0eef9;
      display: flex;
      flex-direction: column;

      &:hover {
        transform: translateY(-4px);
        box-shadow: 0 8px 16px rgba(0, 0, 0, 0.08);
        border-color: #d9ecff;
      }

      /* 图片区域 */
      .card-img-box {
        flex-shrink: 0;
        position: relative;
        height: 270px;
        width: 100%;
        background: #f5f7fa;
        overflow: hidden;

        img {
          width: 100%;
          height: 100%;
          object-fit: cover;
          transition: transform 0.5s;
        }

        /* 鼠标悬停图片微放大 */
        &:hover img {
          transform: scale(1.05);
        }

        /* 状态标签 (左上) */
        .status-tag {
          position: absolute;
          top: 14px;
          left: 14px;
          width: 64px;
          height: 30px;
          background: rgba(109, 212, 0, 0.5);
          border-radius: 8px;
          color: #fff;
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 5px;
          backdrop-filter: blur(4px);

          .dot {
            width: 14px;
            height: 14px;
            border-radius: 50%;
            background-color: #52c41a;
            box-shadow: 0px 1px 0px 0px rgba(0, 0, 0, 0.5);
          }
        }

        /* 关注按钮 (右上) */
        .follow-action {
          position: absolute;
          top: 14px;
          right: 14px;
          cursor: pointer;
          transition: transform 0.3s;
          .icon {
            display: inline-block;
            width: 24px;
            height: 21.33px;
            background-repeat: no-repeat;
            background-size: cover;
            background-position: center;

            &.follow-icon {
              background-image: url("~@/assets/markers/heart.png");
            }
            &.unfollow-icon {
              background-image: url("~@/assets/markers/heart-empty.png");
            }
          }
          &:hover {
            transform: scale(1.2);
          }
        }
        .info-panel {
          position: absolute;
          width: 100%;
          bottom: 0px;
          left: 0px;
          background: rgba(255, 255, 255, 0.8);
        }
        .device-info {
          padding: 8px;
          display: flex;
          align-items: flex-start;
          .icon {
            width: 30px;
            height: 30px;
          }
          .info-header {
            margin-left: 3px;
            flex: 1;
            display: flex;
            flex-direction: column;
            overflow: hidden;
          }

          .device-type {
            margin-left: auto;
            white-space: nowrap;
            flex-shrink: 0;
            overflow: hidden;
            text-overflow: ellipsis;
          }

          .device-name {
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            font-size: 14px;
            font-weight: 600;
          }
          .time {
            margin-top: 3px;
            white-space: nowrap;
          }
        }

        /* 信息区域 */
        .card-info {
          height: 75px;
          border-top: 1px solid #e0eef9;
          padding: 14px 16px;
          display: flex;
          flex-direction: column;
          gap: 3px;
          background: rgba(255, 255, 255, 0.8);
        }
      }

      /* 离线置灰 */
      &.is-offline {
        color: #8e8e93;
        .poster {
          filter: grayscale(1);
          opacity: 0.8;
        }
        .status-tag {
          background: rgba(255, 255, 255, 0.5);
          .dot {
            background-color: rgba(255, 255, 255, 1);
          }
        }
      }
    }
  }

  .empty-placeholder {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 80px 0;

    .empty-img {
      font-size: 64px;
      color: #dcdfe6;
      margin-bottom: 16px;
    }

    p {
      color: #909399;
      font-size: 14px;
    }
  }
}

/* 移动端适配 */
@media (max-width: 768px) {
  .header-bar {
    flex-direction: column;
    height: auto;
    padding: 10px;
    gap: 10px;

    .header-tools {
      width: 100%;
      justify-content: space-between;
      .region-select {
        flex: 1;
      }
    }
  }
}
</style>